<template>
    <section :class="clss" v-cloak>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-10">
                    <div v-for="item in items" class="post wow fadeIn">
                        <a :href="'/media-room/'+item.slug"><figure class="post-image"><img :src="'/static/files/'+item.image" alt=""></figure></a>
                        <div class="post-content"><b class="date">{{item.created_at|nice}}</b>
                            <h4><a :href="'/media-room/'+item.slug">{{item.title}}</a></h4>
                            <div class="body" v-html="trim(item.body)">
                            </div>

                            <a :href="'/media-room/'+item.slug">Read More</a>
                        </div>
                        <!-- end post-content -->
                    </div>
                    <!-- end post -->

                    <div class="more" v-if="items" >
                        <a @click.prevent="loadMore" href="#"><img width="30" :src="'/static/img/loadmore.svg'" alt=""></a>
                    </div>
                </div>
                <!-- end col-10 -->
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </section>

</template>

<script>

    import axios from 'axios';
    let dateFns = require('date-fns')

    let trimHtml = require('trim-html');

    export default {
        props: [],
        data: function () {
            return {
                items: [],
                page: 1,
                itemsPerPage: 9,
                search: {},
              clss: 'blog'
            }
        },
        mounted() {
            this.loadItems();
        },
        filters: {
            nice(dt){
                return  dateFns.format(dateFns.fromUnixTime(Date.parse(dt)/1000),'dd MMMM, yyyy');
            }
        },

        methods: {

            trim(text) {
              if (text){
                return trimHtml(text, {limit: 300}).html;
              }

            },
            loadItems() {
              if (location.href.includes('/media-room-arabic/')) {
                this.search = {tag: 'arabic'};
                this.clss = 'blog arabic';
              }
                axios.post(`/api/post?page=${this.page}&per_page=${this.itemsPerPage}`, {search: this.search}).then(res => {
                    this.items = this.items.concat(res.data.items);

                    this.itemsLength = res.data.total;

                });

            }
            ,
            loadMore(){
                this.page += 1;
                this.loadItems();

            }

        }
    }
</script>

<style lang="scss">


    $color-blue: #9a181e;
    $color-turquaz: #e5bec0;
    $color-dark: #131314;

    [v-cloak] > * { display:none }
[v-cloak]::before { content: "loading…" }


    /* BLOG */
    .blog {
        margin-top: 162px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 10px 0;
      min-height: 100vh;


        .date {
            color: #999;
        }

        .post {
            width: 100%;
            display: block;
            float: left;
            margin: 12px 0;
            background: #fff;
            box-shadow: 0 0 40px rgba(0, 0, 0, 0.05);

            &.single .post-content {
                padding: 60px;
            }

            .post-image {
                width: 100%;
                display: block;
                margin-bottom: 0;


                img {

                    width: 100%;
                    max-height: 500px;
                    object-fit: cover;
                    transition: all 0.3s ease;
                    &:hover {
                        filter: saturate(1.2);
                    }
                }

            }

            .post-content {
                width: 100%;
                display: block;
                padding: 30px;

                .author {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    margin: 0;

                    img {
                        height: 60px;
                        float: left;
                        margin-right: 15px;
                        border-radius: 50%;
                    }

                    figcaption {
                        display: inline-block;

                        h6 {
                            font-weight: 600;
                            margin-top: 10px;
                            margin-bottom: 0;
                        }

                        small {
                            font-weight: 300;
                            opacity: 0.6;
                        }
                    }
                }

                .post-categories {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    margin: 30px 0;
                    padding: 0;
                    padding-top: 30px;
                    border-top: 1px solid #eee;

                    li {
                        display: inline-block;
                        list-style: none;
                        margin-right: 5px;

                        a {
                            font-weight: 600;
                            font-size: 11px;
                            background: $color-dark;
                            color: #fff;
                            line-height: 1;
                            padding: 3px 6px;

                            &:hover {
                                background: $color-blue;
                                text-decoration: none;
                            }
                        }
                    }
                }

                .social-share {
                    width: 100%;
                    float: left;
                    padding: 0;
                    margin-bottom: 40px;
                    text-align: center;

                    li {
                        float: left;
                        margin-right: 5px;
                        padding: 0;
                        list-style: none;

                        &.facebook a {
                            background: #475993;
                        }

                        &.twitter a {
                            background: #76a9ea;
                        }

                        &.google-plus a {
                            background: #f34a38;
                        }

                        &.linkedin a {
                            background: #0077b7;
                        }

                        &.youtube a {
                            background: #f61c0d;
                        }

                        a {
                            width: 44px;
                            height: 44px;
                            line-height: 44px;
                            float: left;
                            background: $color-dark;
                            color: #fff;
                            border: none;
                            border-radius: 0;
                        }
                    }
                }

                .image-left {
                    width: 40%;
                    float: left;
                    margin-right: 30px;
                    margin-bottom: 30px;
                    margin-top: 20px;
                }

                .image-full {
                    width: 100%;
                    display: block;
                    margin: 30px 0;
                }

                blockquote {
                    background: $color-turquaz;
                    padding: 30px;
                    font-size: 19px;
                    line-height: 1.6;
                }

                h5 {
                    font-weight: 700;
                    margin-top: 30px;
                }

                ul {
                    margin-bottom: 30px;
                    padding-left: 20px;

                    li {
                        margin: 0;
                    }
                }

                b {
                    width: 100%;
                    display: block;
                    margin-bottom: 10px;
                    text-transform: uppercase;
                    font-size: 14px;
                }

                h4 {
                    display: block;
                    font-size: 28px;
                    line-height: 1.2;
                    margin-bottom: 20px;

                    a {
                        color: $color-dark;

                        &:hover {
                            color: $color-blue;
                            text-decoration: none;
                        }
                    }
                }
            }
        }

        .sidebar {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            padding-left: 80px;
            margin: 50px 0;

            .widget {
                width: 100%;
                display: block;
                margin-bottom: 50px;
                background: #fff;
                box-shadow: 0 0 40px rgba(0, 0, 0, 0.05);
                padding: 40px;
                padding-top: 0;

                .categories {
                    width: 100%;
                    display: block;
                    margin: 0;
                    padding: 0;

                    li {
                        width: 100%;
                        display: block;
                        margin: 0;
                        padding: 3px 0;
                        list-style: none;

                        a {
                            margin: 0;

                            &:hover {
                                color: $color-blue;
                                text-decoration: none;
                            }
                        }

                        span {
                            float: right;
                            opacity: 0.5;
                        }
                    }
                }

                .tags {
                    width: 100%;
                    display: block;
                    margin: 0;
                    padding: 0;

                    li {
                        display: inline-block;
                        margin-right: 5px;
                        margin-bottom: 5px;
                        padding: 0;
                        list-style: none;

                        a {
                            color: #fff;
                            background: $color-blue;
                            display: inline-block;
                            font-size: 13px;
                            padding: 3px 6px;

                            &:hover {
                                color: $color-blue;
                                background: $color-turquaz;
                                text-decoration: none;
                            }
                        }
                    }
                }

                .side-gallery {
                    display: block;
                    margin-left: -1px;
                    margin-right: -1px;
                    padding: 0;

                    li {
                        width: 50%;
                        float: left;
                        margin: 0;
                        padding: 1px;
                        list-style: none;
                    }
                }

                p {
                    margin-bottom: 0;
                }

                form {
                    margin: 0;

                    input[type="search"] {
                        width: 100%;
                        margin-bottom: 10px;
                    }
                }

                .title {
                    width: 100%;
                    border-bottom: 2px solid #eee;
                    line-height: 1;
                    font-size: 18px;
                    font-weight: 700;
                    text-transform: uppercase;
                    padding: 30px 0;
                    margin-bottom: 30px;
                    color: $color-blue;
                    position: relative;

                    &:before {
                        content: "";
                        width: 60px;
                        height: 2px;
                        background: $color-turquaz;
                        position: absolute;
                        left: -40px;
                        bottom: -2px;
                    }
                }
            }
        }

    }

    .more {
        text-align: center;
    }
    .more img {
        opacity: 0.7;
    }
    .more img:hover {
        transform: translateY(-1px);
        opacity: 1;
    }
    .more img:active {
        transform: translateY(1px);
    }

    .blog.arabic {
      text-align: right;

    }


</style>